require("./thirdparty/cookielaw.js");

// TODO: UTILIZANDO MIN NO FUNCIONA MODAL DE BS!!!
window.$ = window.jQuery = require('jquery');
window.Cookies = require('js-cookie');

// Tether (required by Bootstrap 4)
// window.Tether = require('tether');

window.Popper = require('popper.js');
// Bootstrap 4
require('bootstrap/dist/js/bootstrap');
// Usamos uno modificado por un par de extras que necesitamos:
// require('devbridge-autocomplete/dist/jquery.autocomplete');
require("./thirdparty/jquery.autocomplete.js");

// Funcion tontorrona para reproducir audios
require("./thirdparty/jquery.playSound.js");

// Lib para jugar con fechas y horas y humanize
window.moment = require('moment/min/moment-with-locales');
window.moment.locale($("html").attr("lang"));

// TODO: Antiguo contador
// require("jquery-countdown");

require("./thirdparty/TimeCircles.js");

require("./thirdparty/jquery.backstretch.js");
window.WOW = require("./thirdparty/wow.js").WOW;

window.InfiniteScroll = require('infinite-scroll');

// Datepicker
require('jquery-ui/ui/widgets/datepicker.js');
// TODO: Por ahora solo cargamos ES para datepicker... revisar con i18n
require('jquery-ui/ui/i18n/datepicker-es.js');

// Phone numbers
require('intl-tel-input/build/js/intlTelInput-jquery.js');

// Survey: formBuilder by Kevin Chappell
require('formBuilder/dist/form-render.min.js');